import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  debug: false, //Enable / disable logging & other dev features
  token: "SnKuS4ZoKbrFyYhEvR9zusxLSLfW4Mn5xxaszeIKzmYqTdnbFGXmU7LRZxFsMyiCVpPXRnKi5NEw90mTAbbel2B9SphnNDuPliFFb1n6tAEnaKqnvmYjPZ5JZSkc1le4",

  appVersion: "3.16", //Versão da aplicação - incrementa a cada nova implementação
  appBuild: "3",//Build dentro da versão - incrementa a cada correção dentro da versão
  appDate: "27.08.2024", //Data da Build

  loadingApp: false,
  tempProtocol: 'https',
  tempDomain: 'sualojaonline.com.br',
  
  affiliateFreeDays: 30,

  loader: {
    loading: false,
    title: '',
    subtitle: '',
    main: false,
  },

  info: {
    msg: '',
    type: 'info',
  },

  //localhost:8080/#/inicio?affid=999&email=paulopina@iset.com&utm_source=XXX&utm_medium=YYY&utm_campaign=ZZZ&coupon=ABC123&gid=11
  
  session: {
    id: '',
    email: '',
    token: '',
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    coupon: '',//Default coupon
    affid: '', //Affiliate ID
    gid: '', //Plan Group ID
    groupTitle: '',
    pid: '', //Plan ID
    cycle: 'monthly', //Billing Cycle
    ipAddress: ''    
  },

  client: {
    id: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    loggedIn: '',
    access_token: ''
  },

  password: '',

  business: {
    docType: '',
    docNumber: '',
    company: '',
    mainSegments: '',
    usedMarketplaces: '',
    usedPlatforms: '',
  },

  address: {
    CEP: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    cityCode: '',
    state: '',
    stateCode: '',
    country: 'BR',
  },

  domain: {
    protocol: 'https',
    subdomain: '', //www loja store etc
    base: '',
    extension: '', //com net com.br etc
    status: '',    
  },

  plan: {
    freeDays: 0,
    id: 0,
    name: '',
    icon: '',
    description: '',
    monthly: '',
    annually: '',
    emails: 0
  },
  
  order: {
    id: 0,    
    status: '',
    affid: 0, //after checking at backend    
    affName: '',

    coupon: '', //after checking at backend    
    couponFreeDays: 0,
    couponType: '', //Free Setup, Percentage, Fixed Amount, Price Override
    couponValue: -1,
    couponCycles: '',
    couponPackages: '',
    couponText: '',

    hosting: true,
    hostingPrice: 27,
    cycle: '',
    paymentMethod: 'creditcard', //pix, boleto
    totalDays: 0,
    total: 0,
    nextDate: '',
    warningMsg: '',
    errorMsg: '',
    
    creditcard: {
      number: '',
      name: '',
      month: '',
      year: '',
      cvv: ''
    }
  },

  invoice: {
    id: 0,
    total: 0,
    duedate: '',
    status: '',
    url: '',
  },

  hosting: {
    id: 0,
    status: '',
    username: '',
    password: '',
    price: 27,
  },

  ecommerce: {
    id: 0,
    status: '',
    username: '',
    password: '',
    package: 0,
    packageName: '',
    emails: 0,    
    price: 0,
    userCreated: false,
    userToken: '',
  },
}

const mutations = {
  loading(){ 
    state.loader.loading  = true;
    state.loader.title    = 'Aguarde';
    state.loader.subtitle = 'Carregando informações...';
    state.loader.main     = true;
  },
  
  loaded(){ 
    state.loader.loading  = false;
    state.loader.title    = '';
    state.loader.subtitle = '';
    state.loader.main     = false;
  },

  loader(state, [loading = false, title = "", subtitle = "", main = false]){
    state.loader.loading  = loading;
    state.loader.title    = title;
    state.loader.subtitle = subtitle;
    state.loader.main     = main;
  },

  setAppLoaded(state, value) {
    state.appLoaded = value;
  },

  info(state, [msg = "", type = "info"]){
    state.info.msg   = msg;
    state.info.type  = type;
  },

  session (state, [variable, value]) {
    state.session[variable] = value;    
  },

  client (state, [variable, value]) {
    state.client[variable] = value;
  },

  password (state, value) {
    state.password = value;
  },

  business (state, [variable, value]) {
    state.business[variable] = value;
  },

  address (state, [variable, value]) {
    state.address[variable] = value;
  },

  domain (state, [variable, value]) {
    state.domain[variable] = value;
  },

  plan (state, [variable, value]) {
    state.plan[variable] = value;
  },

  order (state, [variable, value]) {
    state.order[variable] = value;
  },

  invoice (state, [variable, value]) {
    state.invoice[variable] = value;
  },

  hosting (state, [variable, value]) {
    state.hosting[variable] = value;
  },

  ecommerce (state, [variable, value]) {
    state.ecommerce[variable] = value;
  },  

}

export default new Vuex.Store({
  state,
  mutations,
})
